import styled from "styled-components";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";
import { SideMenuLinkIconBase } from "./base/side-menu-link-icon-base.box";

const CasinogamesSideMenuDefaultIcon = styled(SideMenuLinkIconBase)`
    background-position: ${({active}) => active ? "-241px -477px" : "-242px -447px"};
`;

const CasinogamesSideMenuHarrahsWsopIcon = styled(CasinogamesSideMenuDefaultIcon)`/* harrahs */
    background-position: ${({active}) => active ? "-241px -477px" : "-241px -447px"};
`;

export const CasinogamesSideMenuIcon = styledByTheme(CasinogamesSideMenuDefaultIcon)
    .forHarrahs(CasinogamesSideMenuHarrahsWsopIcon)
    .forWsop(CasinogamesSideMenuHarrahsWsopIcon).apply();
